export default "__VITE_ASSET__$xKtswaI__"